'use client';

import { FC, ReactNode, createContext, useContext, useState } from 'react';

import { CognitoClient } from '~/libs/client/cognito';

interface CognitoContext {
  cognito: CognitoClient;
}

const cognitoContext = createContext<CognitoContext>({
  // NOTE: /src/app/layout.tsx でProviderを用意しているので、初期化されていない状態で使うことはないと思われる
  cognito: {} as CognitoClient,
});

export const useCognito = () => {
  return useContext(cognitoContext);
};

export const CognitoProvider: FC<{
  userPoolId: string;
  clientId: string;
  children: ReactNode;
}> = ({ userPoolId, clientId, children }) => {
  const [cognito] = useState(() => {
    // NOTE: ビルド時にはCognitoClientを生成しない
    if (process.env.NEXT_BUILD === 'yes') {
      return {} as CognitoClient;
    }
    return new CognitoClient(userPoolId, clientId);
  });

  return (
    <cognitoContext.Provider value={{ cognito }}>
      {children}
    </cognitoContext.Provider>
  );
};
